export default __webpack_public_path__ + "static/media/unpublished.7d456d0f.svg";